module.exports = __webpack_public_path__ + "img/product-packaging-link-lg.e6615b94.png";